import PersianUtil from "@/services/persianUtiles/numberPersianUtiles";
import { phoneNumberValidation } from "@/utilities/validation";
import * as Yup from "yup";

export const schema = Yup.object()
  .shape({
    phoneNumber: Yup.string()
      .required("شماره تلفن را وارد نمایید")
      .matches(phoneNumberValidation, "شماره تلفن را به درستی وارد نمایید"),
    firstName: Yup.string(),
    lastName: Yup.string(),
    referrer: Yup.string().nullable().max(200, "معرف نمی‌تواند بیشتر از ۲۰۰ کاراکتر باشد"),
    birthDate: Yup.string(),
    dateOfMarriage: Yup.string(),
    year: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(1330, "سال را درست وارد نمایید")
      .max(PersianUtil.getCurrentPersianYear(), "سال را درست وارد نمایید")
      .nullable(),
    month: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(1, "ماه را درست وارد نمایید")
      .max(12, "ماه را درست وارد نمایید")
      .nullable(),
    day: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(1, "روز را درست وارد نمایید")
      .max(31, "روز را درست وارد نمایید")
      .nullable(),
  })
  .test("all-or-none-date", "", function (values) {
    const { year, month, day } = values;
    const has = (v: number | null | undefined | string) =>
      v !== null && v !== undefined && v !== "";

    const allEmpty = !has(year) && !has(month) && !has(day);
    const allFilled = has(year) && has(month) && has(day);
    if (allEmpty || allFilled) return true;

    // choose which field should show the error
    if (!has(year))
      return this.createError({
        path: "year",
        message: "سال را وارد کنید",
      });
    if (!has(month))
      return this.createError({
        path: "month",
        message: "ماه را وارد کنید",
      });
    return this.createError({
      path: "day",
      message: "روز را وارد کنید",
    });
  });
